import React from 'react';

import {
  Box,
  Grid,
  Typography
} from '@mui/material';
import _ from 'lodash';
import {
  activityTemplates,
  AuthWrapper,
  BackButton,
  DownloadableResourceBox,
  legalDocumentsDataService,
  LoadingOverlay
} from 'modules';



export const LegalDocumentActivity: React.FC = () => {
  const { data, loading } = legalDocumentsDataService.useLegalDocuments();

  const getApiFileData = React.useCallback((title: legalDocumentsDataService.LegalDocument) => {
    return _.find(data.legalDocuments, d => d.title === title);
  }, [data]);



  return (
    <AuthWrapper.FC>
      <activityTemplates.BaseActivityTemplate.FC>
        <LoadingOverlay active={loading} />

        <BackButton.FC label="Back to Legal" />

        <Box marginBottom={4}>
          <Typography variant="h2">Template Legal Documents</Typography>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={4}>
            <DownloadableResourceBox.FC
              title="Certificate of Incorporation"
              description={<Typography>The Certificate of Incorporation (COI) or charter establishes the rights, preferences, privileges, and restrictions of each class and series of a Corporation's stock.</Typography>}
              thumbnailFilename="legal_certificate_of_incorporation.png"
              apiFileData={getApiFileData('Certificate of Incorporation')}
              height={240}
              layoutVariant="document" />
          </Grid>
          <Grid item xs={4}>
            <DownloadableResourceBox.FC
              title="Stock Purchase Agreement"
              description={<Typography>The Stock Purchase Agreement sets forth the basic terms of the purchase and sale of the preferred stock to the investors (such as the purchase price, closing date, conditions to closing) and identifies the other financing documents.</Typography>}
              thumbnailFilename="legal_stock_purchase_agreement.png"
              apiFileData={getApiFileData('Stock Purchase Agreement')}
              height={240}
              layoutVariant="document" />
          </Grid>
          <Grid item xs={4}>
            <DownloadableResourceBox.FC
              title="Investors' Rights Agreement"
              description={<Typography>The Investors' Rights Agreement (IRA) covers information rights, registration rights, contractual “rights of first offer” or “preemptive” rights, and various post-closing covenants of the Company.</Typography>}
              thumbnailFilename="legal_investor_rights_agreement.png"
              apiFileData={getApiFileData('Investors\' Rights Agreement')}
              height={240}
              layoutVariant="document" />
          </Grid>
          <Grid item xs={4}>
            <DownloadableResourceBox.FC
              title="Voting Agreement"
              description={<Typography>The Voting Agreement specifies Board structure and observer involvement, drag along rights, and other rights of sale.</Typography>}
              thumbnailFilename="legal_voting_agreement.png"
              apiFileData={getApiFileData('Voting Agreement')}
              height={240}
              layoutVariant="document" />
          </Grid>
          <Grid item xs={4}>
            <DownloadableResourceBox.FC
              title="ROFR"
              description={<Typography>The ROFR governs how and to whom founders and employees can sell their stock.</Typography>}
              thumbnailFilename="legal_right_of_first_refusal.png"
              apiFileData={getApiFileData('ROFR')}
              height={240}
              layoutVariant="document" />
          </Grid>
        </Grid>
      </activityTemplates.BaseActivityTemplate.FC>
    </AuthWrapper.FC>
  );
};
